import { deleteCookie, readCookie, writeCookie } from './cookie';
import { cookieConfig } from './cookie-config';
import { randomString } from './utils';
import { isBrowser } from './WebApi';
const { TEST_COOKIE_KEY } = cookieConfig;
// Exported for testing
export function makeGetRootDomainCached() {
    let cache;
    return () => {
        if (!isBrowser) {
            return '';
        }
        if (cache) {
            return cache;
        }
        const parts = `${window.location.hostname}`.split('.');
        const testValue = randomString();
        let domain = window.location.hostname;
        let test = '';
        for (let i = 0; i < parts.length; i += 1) {
            try {
                domain = parts.slice(-(i + 1)).join('.');
                writeCookie(TEST_COOKIE_KEY, testValue, domain, 1);
                test = readCookie(TEST_COOKIE_KEY);
                deleteCookie(TEST_COOKIE_KEY, domain);
                if (test === testValue) {
                    break;
                }
            }
            catch (_e) { }
        }
        cache = domain;
        return domain;
    };
}
export const resetGetRootDomain = () => {
    getRootDomain = makeGetRootDomainCached();
};
/**
 * Function for getting the highest cookie domain where a cookie can be placed.
 * This is done by trying to set and then read back a cookie at the tld, and
 * then working downwards.
 *
 * This function is memoized as `window.location.hostname` is supposed to be
 * immutable during the lifetime of the code.
 *
 * @returns {string} the top domain for setting cookies. Example: aftonbladet.se
 */
export let getRootDomain = makeGetRootDomainCached();
//# sourceMappingURL=getRootDomain.js.map